import React from 'react';
import {service as ContactService} from '../../../../Services/ContactService';
import {service as RelationshipService} from '../../../../Services/RelationshipService';

export class UpdateContactDetailsActivityFeedItemDescription extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            relationships: []
        };
    }

    componentDidMount() {
        RelationshipService.Get()
            .then((x) => {
                this.setState({ relationships: x.result });
            });

        if(this.props.CustomEventData && this.props.CustomEventData.value) {
            ContactService.GetContact(this.props.CustomEventData.value)
                .then((x) => {
                    this.setState({ contact: x.result });
                })
                .catch((err) => this.setState({contact: null}));
        }
    }

    getRelationship = () => {
        let id = this.props.CustomEventData ? this.props.CustomEventData.relationshipId : null;

        if(id) {
            let relationship = this.state.relationships.find((x) => x.relationshipId == id);

            if(relationship) {
                return relationship;
            }
        }

        return null
    };

    getContactName = () => {
        const {CustomEventData = {}} = this.props;

        const contactName = ContactService.GetTitle(CustomEventData);
        if(contactName !== "") { return contactName }
        return null;
    };

    render() {
        let relationship = this.getRelationship();
        let contactName = this.getContactName();
        let relationshipText = "";

        if(relationship) {
            if(contactName) {
                contactName = contactName + "'s";
                relationshipText = "(" + relationship.name + ")";
            } else {
                relationshipText = relationship.name;
            }
        }

        return <p>
                    {this.props.Event.Activity.User.name} {this.props.GetPhrase()} {contactName ? contactName : "the"} {relationshipText} {this.props.CustomEventData ? this.props.CustomEventData.fieldName : ""}.
                </p>;
    }
}
